module.exports = __webpack_public_path__ + "img/black.a9548ed7.png";